module.exports = __webpack_public_path__ + "img/sw.da90f0ab.png";